export class Constants {

	// Roles
	static readonly ROLE_LOCAL = 'local';
	static readonly ROLE_NORMAL = 'normal';
	static readonly ROLE_ADMIN = 'admin';

	static readonly OKTA = 'okta';

	// Common
	static readonly REFRESH_SPINNER_DELAY = 1000;
	static readonly APP_MODE_CLOUD = 'cloud';

	// Configuration - General - General Section
	static readonly CONF_GEN_WORKING_DIRECTORY = 'workingDirectory';
	static readonly CONF_GEN_BATCH_SIZE_DELETING_JOBS = 'batchSizeDeletingJobs';
	static readonly CONF_GEN_REFRESH_LAST_HOUR = 'refreshLastHour';
	static readonly CONF_GEN_SECONDS = 'seconds';

	// Configuration - General - Log Section
	static readonly CONF_LOG_MODE = 'mode';
	static readonly CONF_LOG_FILE = 'file';
	static readonly CONF_LOG_FILENAME = 'filename';
	static readonly CONF_LOG_MAX_BACKUP_FILES = 'maxBackupFiles';
	static readonly CONF_LOG_MAX_SIZE = 'maxSize';
	static readonly CONF_LOG_MAX_SIZE_UNITS = 'maxSizeUnits';
	static readonly CONF_LOG_TCP = 'tcp';
	static readonly CONF_LOG_UDP = 'udp';
	static readonly CONF_LOG_SERVER = 'server';
	static readonly CONF_LOG_PORT = 'port';
	static readonly CONF_LOG_CONSOLE = 'console';
	static readonly CONF_LOG_LEVEL = 'level';
	static readonly CONF_LOG_INFO = 'info';
	static readonly CONF_LOG_DEBUG = 'debug';
	static readonly CONF_LOG_ERROR = 'error';
	static readonly CONF_LOG_WARNING = 'warning';
	static readonly CONF_LOG_TRACE = 'trace';
	static readonly CONF_LOG_ALL = 'all';
	static readonly CONF_LOG_KB = 'kb';
	static readonly CONF_LOG_MB = 'mb';
	static readonly CONF_LOG_GB = 'gb';
	static readonly CONF_LOG_CUSTOM_MESSAGE_FORMAT = 'customMessageFormat';
	static readonly CONF_LOG_CUSTOM_DATE_FORMAT = 'customDateFormat';
	static readonly CONF_LOG_DELETE = 'logDeleted';

	// Configuration - General - Sms Section
	static readonly CONF_SMS_PHONE_NUMBER = 'smsPhoneNumber';
	static readonly CONF_SMS_ACCOUNT = 'smsAccount';
	static readonly CONF_SMS_TOKEN = 'smsToken';

	// Configuration - AlertRules
	static readonly CONF_ALERT_RULES_RULE_NAME = 'rule_name';
	static readonly CONF_ALERT_RULES_COLOR = 'color';
	static readonly CONF_ALERT_RULES_RULE_DESCRIPTION = 'rule_description';
	static readonly CONF_ALERT_RULES_PRIORITY = 'priority';
	static readonly CONF_ALERT_RULES_MEASURED_RESOURCE = 'measured_resource';
	static readonly CONF_ALERT_RULES_LOWER_HIGHER = 'lower_higher';
	static readonly CONF_ALERT_RULES_PERCENT_LIMIT = 'percent_limit';
	static readonly CONF_ALERT_RULES_PERCENT_LIMIT_LABEL = 'percent_limit_label';
	static readonly CONF_ALERT_RULES_TIME_TO_ALERT_FOR = 'for';
	static readonly CONF_ALERT_RULES_TIME_TO_ALERT = 'time_to_alert';
	static readonly CONF_ALERT_RULES_TIME_UNIT = 'time_unit';
	static readonly CONF_ALERT_RULES_RULE_ALIAS = 'rule_alias';
	static readonly CONF_ALERT_RULES_RULE_ALIAS_VIA = 'via';
	static readonly CONF_ALERT_RULES_RULE_ALIAS_ALIAS = 'alias';

	// Configuration - Engines
	static readonly CONF_ENGINES_ENGINE_NAME = 'name';
	static readonly CONF_ENGINES_URL = 'url';
	static readonly CONF_ENGINES_STATUS = 'currentState';
	static readonly CONF_ENGINES_SINCLAIR_INDEX = 'aliasName';

	// Configuration - Maintenance
	static readonly CONF_SELF_MAINTENANCE_ENABLE = 'enable';
	static readonly CONF_SELF_MAINTENANCE_START_MAINTENANCE = 'startMaintenance';
	static readonly CONF_SELF_MAINTENANCE_ENABLE_REMOVE_LOG = 'enableRemoveLogs';
	static readonly CONF_SELF_MAINTENANCE_DAYS_KEEP_LOG = 'daysKeepLogs';
	static readonly CONF_SELF_MAINTENANCE_ENABLE_REMOVE_DATA = 'enableRemoveData';
	static readonly CONF_SELF_MAINTENANCE_DAYS_KEEP_DATA = 'daysKeepData';
	static readonly CONF_SELF_MAINTENANCE_ENABLE_REMOVE_JOB = 'enableRemoveJobs';
	static readonly CONF_SELF_MAINTENANCE_DAYS_KEEP_JOB = 'daysKeepJobs';

	// Statistics
	static readonly STATISTICS_JOB_IDJOB = 'idJob';
	static readonly STATISTICS_JOB_DGE = 'dge';
	static readonly STATISTICS_JOB_DOCUMENTS = 'documents';
	static readonly STATISTICS_JOB_TRANSACTIONS = 'transactions';
	static readonly STATISTICS_JOB_PAGES = 'pages';
	static readonly STATISTICS_JOB_FORM_NAME = 'formName';
	static readonly STATISTICS_JOB_STARTED = 'started';
	static readonly STATISTICS_JOB_FINISHED = 'finished';
	static readonly STATISTICS_JOB_QUEUE_TIME = 'queueTime';
	static readonly STATISTICS_JOB_EXECUTION_TIME = 'executionTime';
	static readonly STATISTICS_JOB_TAG1 = 'tag1';
	static readonly STATISTICS_JOB_TAG2 = 'tag2';
	static readonly STATISTICS_JOB_TAG3 = 'tag3';
	static readonly STATISTICS_JOB_TAG4 = 'tag4';
	static readonly STATISTICS_JOB_TAG5 = 'tag5';
	static readonly STATISTICS_JOB_STATUS = 'status';
	static readonly STATISTICS_JOB_PREVIEW = 'preview';

	// Number of Hours
	static readonly NUMBER_OF_HOURS_24 = 24;
	static readonly NUMBER_OF_HOURS_24_LABEL = 'last-24-hours';
	static readonly NUMBER_OF_HOURS_12 = 12;
	static readonly NUMBER_OF_HOURS_12_LABEL = 'last-12-hours';
	static readonly NUMBER_OF_HOURS_6 = 6;
	static readonly NUMBER_OF_HOURS_6_LABEL = 'last-6-hours';
	static readonly NUMBER_OF_HOURS_1 = 1;
	static readonly NUMBER_OF_HOURS_1_LABEL = 'last-hour';
	static readonly NUMBER_OF_HOURS_0 = 0;
	static readonly NUMBER_OF_HOURS_0_LABEL = 'custom';
	static readonly CARD_FILTERS_CUSTOM_HOURS_FROM = 'from';
	static readonly CARD_FILTERS_CUSTOM_HOURS_TO = 'to';

	// Time Units
	static readonly HOURS = 'HOURS';
	static readonly DAYS = 'DAYS';
	static readonly MONTHS = 'MONTHS';
	static readonly YEARS = 'YEARS';
	// Dges
	static readonly DGE_ALL_VALUES = 0;

}